import React, { Component } from "react";
import Modal from "react-modal";
import Constants from "../../Utils/Constants";
import { Document, Page, Text, View, StyleSheet, PDFViewer, Image, } from "@react-pdf/renderer";

// Create styles
const borderColor = 'gray';
const tableBorderColor = 'black';
const styles = StyleSheet.create({
  page: {
    backgroundColor: "#FFFFFF",
    color: "#000000",
    paddingTop: 35,
    paddingBottom: 65,
    paddingHorizontal: 35,
  },
  section: {
    margin: 10,
    padding: 0,
    color: "black",
  },
  centerImage: {
    alignItems: "center",
    flexGrow: 1,
  },
  viewer: {
    width: window.innerWidth / 2, //the pdf viewer will take up all of the width and height
    height: window.innerHeight / 1.5,
  },
  body: {
    paddingTop: 35,
    paddingBottom: 65,
    paddingHorizontal: 35,
  },
  title: {
    fontSize: 24,
    textAlign: 'center',
    fontFamily: 'Oswald'
  },
  author: {
    fontSize: 12,
    textAlign: 'center',
    marginBottom: 40,
  },
  subtitle: {
    fontSize: 18,
    margin: 12,
    fontFamily: 'Oswald'
  },
  text: {
    marginTop: 0,
    marginLeft: 18,
    width: 200,
    // fontSize: 15,
    textAlign: 'justify',
    fontFamily: 'Times-Roman',
    border: 1,
    borderColor: tableBorderColor,
    padding: 8,
  },
  image: {
    marginVertical: 15,
    marginHorizontal: 100,
  },
  header: {
    fontSize: 12,
    marginBottom: 20,
    textAlign: 'center',
    color: borderColor,
  },
  pageNumber: {
    position: 'absolute',
    fontSize: 12,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: 'center',
    color: 'grey',
  },
});

const styleHeader = StyleSheet.create({
  container: {
    flexDirection: 'row',
    bordertColor: tableBorderColor,
    border: 0,
    fontSize: 11,
    marginTop: 15,
    marginLeft: 18,
    //backgroundColor: '#bff0fd',
    alignItems: 'right',
    //height: 24,
    textAlign: 'right',
    fontStyle: 'bold',
    // flexGrow: 1,
  },
  sno: {
    width: '7%',
    alignItems: 'right',
    bordertColor: tableBorderColor,
    border: 1,
    paddingRight: 8,
  },
  firstName: {
    width: '25%',
    textAlign: 'left',
    bordertColor: tableBorderColor,
    border: 1,
    paddingLeft: 8,
  },
  lastName: {
    width: '25%',
    textAlign: 'left',
    bordertColor: tableBorderColor,
    border: 1,
    paddingLeft: 8,
  },
  phone: {
    width: '20%',
    bordertColor: tableBorderColor,
    border: 1,
    textAlign: 'left',
    paddingRight: 8,
  },
  staffName: {
    width: '30%',
    bordertColor: tableBorderColor,
    border: 1,
    textAlign: 'left',
  },
  visitDate: {
    width: '20%',
    bordertColor: tableBorderColor,
    border: 1,
    alignItems: 'left',
    paddingRight: 8,
  },
  signOutDate: {
    width: '20%',
    bordertColor: tableBorderColor,
    border: 1,
    alignItems: 'left',
    paddingRight: 8,
  },
});

const styleRows = StyleSheet.create({
  row: {
    flexDirection: 'row',
    borderColor: tableBorderColor,
    border: 0,
    alignItems: 'right',
    fontSize: 11,
    marginLeft: 18,
    fontStyle: 'normal',
    //height: 24,
  },
  sno: {
    width: '7%',
    textAlign: 'right',
    bordertColor: tableBorderColor,
    border: 1,
    paddingRight: 8,
    fontStyle: 'normal',
  },
  firstName: {
    width: '25%',
    textAlign: 'left',
    bordertColor: tableBorderColor,
    border: 1,
    paddingLeft: 8,
    fontStyle: 'normal',
  },
  lastName: {
    width: '25%',
    textAlign: 'left',
    bordertColor: tableBorderColor,
    border: 1,
    paddingLeft: 8,
    fontStyle: 'normal',
  },
  phone: {
    width: '20%',
    textAlign: 'left',
    bordertColor: tableBorderColor,
    border: 1,
    paddingRight: 8,
    fontStyle: 'normal',
  },
  staffName: {
    width: '30%',
    alignItems: 'left',
    bordertColor: tableBorderColor,
    paddingLeft: "28",
    paddingRight: "28",
    border: 1,
  },
  visitDate: {
    width: '20%',
    textAlign: 'left',
    bordertColor: tableBorderColor,
    border: 1,
    paddingRight: 8,
    fontStyle: 'normal',
  },
  signOutDate: {
    width: '20%',
    textAlign: 'left',
    bordertColor: tableBorderColor,
    border: 1,
    paddingRight: 8,
    fontStyle: 'normal',
  },
});

function PDFVisitsReportDocument({ title, content, isVisible, onClose, bigForm }) {
  // console.log((JSON.stringify(content)))
  let visitDetail = '';
  if (content != undefined) {
    visitDetail = content.map((token, index) => {

      return (
        <View style={styleRows.row} key={index.toString()}>
          <Text style={styleRows.sno}>{++index}</Text>
          <Text style={styleRows.firstName}>{token.firstName}</Text>
          <Text style={styleRows.lastName}>{token.lastName}</Text>
          <Text style={styleRows.phone}>{token.phone}</Text>
          <Text style={styleRows.staffName}>{token.staffName}</Text>
          <Text style={styleRows.visitDate}>{token.visitDate.substr(11, 8)}</Text>
          <Text style={styleRows.signOutDate}>{(token.signOutDate == null) ? '' : token.signOutDate.substr(11, 8)}</Text>
        </View>
      )
    })
    // console.log("visitDetail::: " + (visitDetail))
  }


  return (
    isVisible && (
      <Modal
        style={bigForm ? Constants.defaultBigModalStyle : Constants.defaultModalStyle}
        isOpen={isVisible}
        ariaHideApp={false}
        onRequestClose={onClose ? () => onClose() : null}
        shouldCloseOnOverlayClick={false}
      >
        <div className="modal-content" style={{ height: "600px", width: "900px" }}>
          <div className="modal-header">
            <h5 className="modal-title">{title}</h5>
            {onClose && (
              <a href="#" className="close" onClick={() => onClose()}>
                <em className="icon ni ni-cross" />
              </a>
            )}
          </div>
          <div className="modal-body">
            <PDFViewer style={styles.viewer}>
              <Document>
                <Page style={styles.page} size="A4" orientation="landscape" >
                  <Text style={{ fontSize: 12, textAlign: 'center', marginTop: 30 }}>VISITS LIST</Text>
                  <View style={styleHeader.container} fixed>
                    <Text style={styleHeader.sno}>S/No</Text>
                    <Text style={styleHeader.firstName}>FIRST NAME</Text>
                    <Text style={styleHeader.lastName}>LAST NAME</Text>
                    <Text style={styleHeader.phone}>PHONE NO</Text>
                    <Text style={styleHeader.staffName}>STAFF NAME</Text>
                    <Text style={styleHeader.visitDate}>SIGN IN</Text>
                    <Text style={styleHeader.signOutDate}>SIGN OUT</Text>
                  </View>
                  {visitDetail}

                  <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => (
                    `${pageNumber} / ${totalPages}`
                  )} fixed />
                </Page>
              </Document>
            </PDFViewer>
          </div>
          <div className="modal-footer theme-bg py-0" style={{ height: "4px" }}></div>
        </div>
      </Modal>
    )
  );
}
export default PDFVisitsReportDocument;


// import React, { useState } from 'react';
// import jsPDF from 'jspdf';
// import Modal from 'react-modal';

// // Set up modal root element
// Modal.setAppElement('#root'); // Adjust to your root element ID

// const PdfModal = () => {
//   const [modalIsOpen, setModalIsOpen] = useState(false);
//   const [pdfUrl, setPdfUrl] = useState(null);

//   // Function to generate PDF and open modal
//   const openPdfModal = () => {
//     const doc = new jsPDF();

//     // Sample content for the PDF
//     doc.text("Hello from jsPDF!", 10, 10);

//     // Convert to Blob and create an Object URL
//     const pdfBlob = doc.output('blob');
//     const url = URL.createObjectURL(pdfBlob);
//     setPdfUrl(url);
//     setModalIsOpen(true);
//   };

//   // Close modal and clean up URL
//   const closeModal = () => {
//     setModalIsOpen(false);
//     URL.revokeObjectURL(pdfUrl); // Clean up the Object URL
//     setPdfUrl(null);
//   };

//   return (
//     <div>
//       <button type="button" className="btn btn-lg btn-primary" onClick={openPdfModal}>Generate PDF and Open Modal</button>

//       <Modal
//         isOpen={modalIsOpen}
//         onRequestClose={closeModal}
//         contentLabel="PDF Modal"
//         style={{
//           content: { width: '900px', height: '600px', margin: 'auto' }
//         }}
//       >
//         <button onClick={closeModal} style={{ float: 'right' }}>Close</button>
//         {pdfUrl ? (
//           <iframe
//             src={pdfUrl}
//             width="100%"
//             height="100%"
//             title="PDF Preview"
//             style={{ border: 'none' }}
//           />
//         ) : (
//           <p>Loading PDF...</p>
//         )}
//       </Modal>
//     </div>
//   );
// };

// export default PdfModal;

